import { getApiUrl } from './apiBaseUrl'

async function getData(url = '', signal) {
  const controller = new AbortController()
  const validSignal = signal instanceof AbortSignal ? signal : controller.signal
  const fullUrl = getApiUrl(url)

  const response = await fetch(fullUrl, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    signal: validSignal,
  })

  let responseJson = {}
  try {
    responseJson = await response.json()
  } catch {
    // Some non-2xx responses may return empty body or non-JSON payloads (e.g. HTML 404).
    responseJson = {}
  }

  if (!response.ok) {
    return {
      ...responseJson,
      error: responseJson?.error || response.statusText || `Request failed with status ${response.status}`,
      status: response.status
    }
  }

  if (responseJson?.redirect) {
    window.location.href = window.location.origin + responseJson.redirect
    return {}
  }

  return responseJson
}

export default getData
